import React, { type FC, type PropsWithChildren } from "react";

import { ButtonCircle } from "../../../ButtonCircle";

import type { ButtonCircleProps } from "../../../ButtonCircle/types";

export type ButtonsCircleViewButtonCircleProps = ButtonCircleProps;

const BUTTONS_CIRCLE_VIEW_BUTTON_CIRCLE_TEST_ID =
    "buttons-circle-view-button-circle-test-id";

const ButtonsCircleViewButtonCircle: FC<
    PropsWithChildren<ButtonsCircleViewButtonCircleProps>
> = ({ children, ...props }) => {
    return (
        <ButtonCircle
            {...props}
            data-tsid={BUTTONS_CIRCLE_VIEW_BUTTON_CIRCLE_TEST_ID}
        >
            {children}
        </ButtonCircle>
    );
};

ButtonsCircleViewButtonCircle.displayName = "ButtonsCircleView.ButtonCircle";

export default ButtonsCircleViewButtonCircle;
